import { entity, JsonapiEntity } from 'jsonapi-transformers';

@entity({ type: 'roles' })
export class RoleRecord extends JsonapiEntity {}
